module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic.e4fede9a.woff2";